<template>
  <div class="create-account-wrap">
    <div class="page-actions">
      <base-button
        type="info"
        icon="el-icon-back"
        @click="$router.push({path: `/app/tenants/${$route.params.id}/customers/${$route.params.customerId}/accounts`})">
        {{ $t('settings.backToAccounts') }}
      </base-button>
    </div>

    <h2 v-if="customer">{{ $t('settings.createAccount') }} - {{ customer.name }}</h2>
    <h2 v-else>{{ $t('settings.createAccount') }}</h2>

    <account-form
      :tenantId="$route.params.id"
      :customerId="$route.params.customerId"
      @submit="onSubmit"
      @cancel="onCancel"
      :loading="loading">
    </account-form>
  </div>
</template>

<script>
import AccountForm from './AccountForm';
import BaseButton from '@/components/common/BaseButton';
import { adminAccountService } from '@/services/AdminAccountService.class';

export default {
  name: "CreateTenantCustomerAccount",
  components: {
    AccountForm,
    BaseButton
  },
  data() {
    return {
      customer: null,
      loading: false
    };
  },
  mounted() {
    this.loadCustomer();
  },
  methods: {
    loadCustomer() {
      import('@/services/CustomerService.class').then(({ customerService }) => {
        customerService.getById(this.$route.params.customerId)
          .then(response => {
            this.customer = response.data;
          })
          .catch(() => {
            this.$message.error(this.$t('settings.genericHttpError'));
          });
      });
    },
    onSubmit(account) {
      this.loading = true;

      // Ensure the account is linked to the customer
      account.customerId = this.$route.params.customerId;

      adminAccountService.createAccount(account)
        .then(() => {
          this.$message.success(this.$t('settings.accountCreated'));
          this.$router.push({
            path: `/app/tenants/${this.$route.params.id}/customers/${this.$route.params.customerId}/accounts`
          });
        })
        .catch((error) => {
          console.error('Fehler beim Erstellen des Kontos:', error);
          this.$message.error(this.$t('settings.genericHttpError'));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onCancel() {
      this.$router.push({
        path: `/app/tenants/${this.$route.params.id}/customers/${this.$route.params.customerId}/accounts`
      });
    }
  }
}
</script>

<style scoped lang="scss">
.create-account-wrap {
  min-width: 0;

  h2 {
    margin: 4px 0 20px;
  }
}

.page-actions {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;
}
</style>
